import { useSession, useTeamInfo } from 'src/hooks';
import { useGetCreditAccountInfoQuery } from 'src/store/services';
import { useMemo } from 'react';
import { CreditAccountPaymentSource } from 'src/types/wallet/models/CreditAccountPaymentSource';

export const useCreditsAccountInfo = () => {
  const { appUser, isTeamsTier, isOpenTier } = useSession();
  const { isOwner, isTeamInfoLoading } = useTeamInfo();

  const { data: creditAccountInfo, isLoading: isCreditAccountInfoLoading } =
    useGetCreditAccountInfoQuery(
      {
        user_id: appUser.user_id,
      },
      {
        skip: isOpenTier || (isTeamsTier && !isOwner),
      },
    );

  return useMemo(
    () => ({
      creditAccountInfo,
      isCreditAccountInfoLoading:
        isCreditAccountInfoLoading || isTeamInfoLoading,
      isCreditAccountConfigured:
        creditAccountInfo &&
        creditAccountInfo.payment_source !== CreditAccountPaymentSource.VIRTUAL,
    }),
    [creditAccountInfo, isCreditAccountInfoLoading, isTeamInfoLoading],
  );
};
